<template>
  <div>
    <v-card class="pt-3 pb-3 mb-3">
      <v-row class="ml-3 mr-3 pt-3">
        <v-col>
          <date-filter store="acquisition" range="1"></date-filter
        ></v-col>
        <v-col>
          <apply-filters :disabled="isLoading" outlined color="secondary" />
        </v-col>
        <v-col>
          <v-btn
            :loading="isCrawlerLoading"
            color="primary"
            @click="triggerCrawler"
            outlined
          >
            Relancer le crawler
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import useAxios from "@/hooks/useAxios";
import ApplyFilters from "@/components/common/filters/ApplyFilters.vue";
import DateFilter from "@/components/common/filters/DateFilter.vue";

export default {
  name: "UtmContentFilters",
  components: {
    ApplyFilters,
    DateFilter,
  },
  data() {
    return { isCrawlerLoading: false };
  },

  setup() {
    const { isLoading, axiosGet, axiosPost } = useAxios();

    return {
      isLoading,
      axiosGet,
      axiosPost,
    };
  },
  methods: {
    async triggerCrawler() {
      this.isCrawlerLoading = true;
      try {
        const params = {
          date_start: this.dateRange[0],
          date_end: this.dateRange[1],
        };
        const response = await this.axiosPost(
          "/acquisition/utm-content/report/trigger-crawler",
          params
        );
        console.log("Crawler relancé avec succès", response);
      } catch (error) {
        console.error("Erreur lors du déclenchement du crawler", error);
      } finally {
        this.isCrawlerLoading = false;
      }
    },
  },

  computed: {
    dateRange() {
      return this.$store.getters["acquisition/getDates"];
    },
  },
};
</script>

<style scoped></style>
